// extracted by mini-css-extract-plugin
module.exports = {"header":"HomeHeader_header__A9aF8","logo":"HomeHeader_logo__T8qyj"};